import { BCMSRecord, BCMSRecordProperty } from "@bcm-dev/bcms-vite";
import { Account } from "model";

/**
* @class TransferTemplate
* @classdesc Class definition for record type from model
* @param {OBJECT} record - record from model to init class
* @extends BCMSRecord
* @example const record = model.transferTemplates[0];
* const transferTemplate = new TransferTemplate(record);
* @property {NUMBER} _id - The id of the template
* @property {STRING} _name - The name of the template
*/
export default class TransferTemplate extends BCMSRecord {
    _id
    _name
    _fromAccount
    _toAccount
    _defaultAmount
    _type
    _maxAmount
    _needsApproval;
    _levelOfApprover
    _note
    _isActive

    constructor(record) {     
      super(record) 
    }
  }
  TransferTemplate.define({
    "recordType":"transferTemplates",
    "recordIDProp":"id",
    "className" : "TransferTemplate",
    "recordProperties":[
      /** 
       * @name id
       * @instance
       * @property get {NUMBER} - gets the id of the template
       * @property set {NUMBER} - sets the id of the template
       * @memberof TransferTemplate
       */
      BCMSRecordProperty.mapToString("id","_id"),
      /** 
       * @name name
       * @instance
       * @property get {STRING} - gets the name of the template
       * @property set {STRING} - sets the name of the template
       * @memberof TransferTemplate
       */
      BCMSRecordProperty.mapToString("name","_name"),

      /** 
       * @name fromAccount
       * @instance
       * @property get {Account} - gets the fromAccount value
       * @property set {Account} - sets the fromAccount value
       * @memberof TransferTemplate
       */
      BCMSRecordProperty.mapToClass("fromAccount","_fromAccount", () => Account),

        /** 
       * @name fromAccount
       * @instance
       * @property get {Account} - gets the toAccount value
       * @property set {Account} - sets the toAccount value
       * @memberof TransferTemplate
       */
        BCMSRecordProperty.mapToClass("toAccount","_toAccount", () => Account),

      /** 
       * @name defaultAmount
       * @instance
       * @property get {BCMSCurrency} - gets the defaultAmount value
       * @property set {BCMSCurrency} - sets the defaultAmount value
       * @memberof TransferTemplate
       */
        BCMSRecordProperty.mapToCurrency("defaultAmount", "_defaultAmount"),

      /** 
       * @name type
       * @instance
       * @property get {STRING} - gets the type value
       * @property set {STRING} - sets the type value
       * @memberof TransferTemplate
       */
      BCMSRecordProperty.mapToString("type", "_type"),

       /** 
       * @name maxAmount
       * @instance
       * @property get {BCMSCurrency} - gets the maxAmount value
       * @property set {BCMSCurrency} - sets the maxAmount value
       * @memberof TransferTemplate
       */
      BCMSRecordProperty.mapToCurrency("maxAmount", "_maxAmount"),

      /** 
       * @name needsApproval
       * @instance
       * @property get {BOOLEAN} - gets the needsApproval of the transfer
       * @property set {BOOLEAN} - sets the needsApproval of the transfer
       * @memberof TransferTransaction 
       */
      BCMSRecordProperty.mapToBoolean("needsApproval", "_needsApproval"),

       /** 
       * @name levelOfApprover
       * @instance
       * @property get {STRING} - gets the levelOfApprover value
       * @property set {STRING} - sets the levelOfApprover value
       * @memberof TransferTemplate
       */
      BCMSRecordProperty.mapToString("levelOfApprover", "_levelOfApprover"),

       /** 
       * @name note
       * @instance
       * @property get {STRING} - gets the levelOfApprover value
       * @property set {STRING} - sets the levelOfApprover value
       * @memberof TransferTemplate
       */
      BCMSRecordProperty.mapToString("note", "_note"),

      /** 
       * @name isActive
       * @instance
       * @property get {STRING} - gets the isActive value. Component specific property.
       * @property set {STRING} - sets the isActive value. Component specific property.
       * @memberof TransferTemplate
       */
      BCMSRecordProperty.mapToString("isActive", "_isActive"),

    ]  
})




